import Dinero from 'dinero.js';


const toDinero = (value) => {
  // Convert string/float to integer cents
  const cents = Math.round((parseFloat(value) || 0) * 100);
  return Dinero({ amount: cents, currency: 'USD' });
};

// export const calculateTotal = (itemPrice, selections, quantity) => {
//   // Base price
//   const base = toDinero(itemPrice);
//   // Extras
//   const extras = Object.values(selections).reduce((sum, opt) => {
//     if (Array.isArray(opt)) {
//       const groupSum = opt.reduce(
//         (s, o) => s.add(toDinero(o.price * (o.qty || 1))),
//         Dinero({ amount: 0, currency: 'USD' })
//       );
//       return sum.add(groupSum);
//     } else {
//       return sum.add(toDinero(opt.price * (opt.qty || 1)));
//     }
//   }, Dinero({ amount: 0, currency: 'USD' }));

//   // Subtotal = base + extras
//   const subtotal = base.add(extras);

//   // Multiply by quantity
//   const total = subtotal.multiply(quantity);

//   // Format for display
//   console.log("amount", total.toFormat('$0,0.00'));
//   return total.toFormat('$0,0.00');
// };

export const calculateTotal = (itemPrice, selections, quantity) => {

  // item price
  const base = toDinero(itemPrice);

  const extras = Object.values(selections).reduce((sum, group) => {
    const options = Array.isArray(group) ? group : [group];

    const groupTotal = options.reduce((optSum, opt) => {
      const parentQty = opt.qty ?? 1;

      // parent price
      let total = toDinero(opt.price || 0).multiply(parentQty);

      // sub modifiers
      if (opt.subSelections) {
        const subTotal = Object.values(opt.subSelections).reduce(
          (subSum, subGroup) => {
            const subOptions = Array.isArray(subGroup)
              ? subGroup
              : [subGroup];

            return subSum.add(
              subOptions.reduce((s, subOpt) => {
                const subQty = subOpt.qty || 1;
                return s.add(
                  toDinero(subOpt.price || 0)
                    .multiply(subQty)
                    .multiply(parentQty)
                );
              }, Dinero({ amount: 0, currency: 'USD' }))
            );
          },
          Dinero({ amount: 0, currency: 'USD' })
        );

        total = total.add(subTotal);
      }

      return optSum.add(total);
    }, Dinero({ amount: 0, currency: 'USD' }));

    return sum.add(groupTotal);
  }, Dinero({ amount: 0, currency: 'USD' }));

  const subtotal = base.add(extras);
  const total = subtotal.multiply(quantity);
  return total.toFormat('$0,0.00');
};

